const fncGlobaleConsole = (props: string | object | object[]) => {
	if (import.meta.env.DEV || import.meta.env.VITE_ENV === 'uat') {
		console.log('LOG:', props)
	}
}

const SetAdobiAnalytics = (props: string) => {
	const value = window._satellite?.getVar?.(props)
	console.log('Adobe Analytics var:', value)
	return value
}


const validateEmail = (email: any) => {
		// Regex standard per una validazione email semplice e funzionale
		const re = /\S+@\S+\.\S+/
		return re.test(email)
	}


type PlaceholderKeys = 'IMPORTO' | 'NUMRATE' | 'RATA' | 'TAN' | 'TAEG' | 'INTERESSI' | 'BOLLO' | 'RENDICONTO' | 'ISTRUTTORIA' |'SPESEGESTIONEPRT' | 'INSTALLMENTAMOUNT'

function replacePlaceholders(template: string, values: Record<string, any>) {
  return template.replace(/\[([^\]]+)\]/g, (_, key) => {
    const normalizedKey = key.trim().toUpperCase()
    return values[normalizedKey] ?? ''
  })
}

/* function replacePlaceholders(
	template: string,
	values: Record<string, string | number>
) {
	return template.replace(/\[([A-Z]+)\]/g, (_, key) => {
		return values[key] !== undefined ? String(values[key]) : `[${key}]`
	})
} */
	
export { fncGlobaleConsole, SetAdobiAnalytics ,validateEmail,replacePlaceholders}
